import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  dataGridNewCell: {
    background: theme.custom.palette.grid.new
  }
}));
const useGridCellStyle = (columns, isFlexible) => {
  const { classes } = useClasses();
  function setColumnsWidth(column) {
    return column.width && column.flex ? {
      ...column,
      flex: isFlexible ? column.flex : void 0,
      width: isFlexible ? void 0 : column.width
    } : column;
  }
  const styledColumns = columns?.map((c) => ({
    ...setColumnsWidth(c),
    cellClassName: (params) => {
      const gridCellClassName = c.cellClassName ? typeof c.cellClassName === "string" ? c.cellClassName : c.cellClassName(params) : "";
      const commonCellClassName = params.row?.isNew ? classes.dataGridNewCell : "";
      return `${gridCellClassName} ${commonCellClassName}`;
    }
  }));
  return styledColumns;
};
export {
  useGridCellStyle
};
//# sourceMappingURL=useGridCellStyle.js.map
